import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'utils/axios/defaults';
import 'utils/axios/interceptors';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './utils/localization/i18n';
import * as Sentry from '@sentry/browser';
import App from './app/App';
import * as serviceWorker from './serviceWorker';
import version from './config/version.json';
import store from './redux/store';
import './index.css';

Sentry.init({
  dsn: 'https://062180d036fd405d8e7263fd45280be6@sentry.io/1859962',
  environment: process.env.NODE_ENV,
  release: `kairos-client@${version.version}`,
});

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
